export default __webpack_public_path__ + "static/media/binance-token.e1a7f383.svg";